module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cp_stills_pet_500_aq_man.7d63a0e1.png";